import * as React from "react"
import { useForm } from "react-hook-form"
import Send from "../../svg/form/send"
import FormFeedback from "../FormFeedback/form-feedback"
import { useState } from "react"

const Estimate = () => {
  var today = new Date()
  const {
    handleSubmit,
    formState: { errors },
    register,
  } = useForm({
    defaultValues: {
      time: today.getHours() + ":" + today.getMinutes(),
    },
  })
  const [success, setSuccess] = useState(false)
  const [systemError, setSystemError] = useState(null)

  const onSubmit = async data => {
    try {
      const response = await fetch(
        "https://na0sctpz6c.execute-api.eu-central-1.amazonaws.com/process/",
        {
          method: "post",
          body: JSON.stringify({
            content: ` 
${data.name}, ${data.email}
Data: ${data.datetime},
Przybliżona liczba gości: ${data.amount},
Wiadomośc: ${data.message},
`,
            email: data.email,
          }),
        }
      )

      if (response.ok) {
        setSuccess(true)
      } else {
        setSuccess(false)
        setSystemError(true)
      }
    } catch (error) {
      setSystemError(true)
    }
  }

  return (
    <form
      className={"client-form"}
      onSubmit={handleSubmit(data => onSubmit(data))}
    >
      <div data-g={"grid"}>
        <div data-g="4 5@md">
          <div className="client-form__copy">
            <h2>Indywidualna oferta dostosowana do Twoich potrzeb!</h2>
            <p>
              Uzupełnij formularz a my przygotujemy dla Ciebie indywidualną
              ofertę, skrojoną na miarę Twoich potrzeb. Potrzebujemy jedynie
              ogólnych informacji na temat przedsięwzięcia - szczegóły
              doprecyzujemy wspólnie.
            </p>
            <p>
              Ogólne pytania dotyczące oferty możesz kierować także do naszych
              dyspozytorów dostępnych 24/7 pod numerem telefonu:{" "}
              <a href="tel:914-615-615">914 615 615</a> lub pisząc na adres{" "}
              <a href="mailto:kontakt@taxiprawobrzeze.pl">mailowy</a>.
            </p>
          </div>
        </div>
        <div data-g="4 7@md">
          <div className={"client-form__calculate"}>
            <div className="form-delimiter">
              <div className={"form-delimiter__text form-delimiter__text--106"}>
                Twoje dane
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <input
                  className={errors.name?.type === "required" ? "error" : ""}
                  placeholder="Imię"
                  {...register("name", {
                    required: true,
                  })}
                />
              </div>
              <div className="form-group">
                <input
                  className={errors.email?.type === "required" ? "error" : ""}
                  placeholder="Adres e-mail"
                  {...register("email", {
                    required: true,
                  })}
                />
              </div>
            </div>

            <div className="form-delimiter">
              <div className={"form-delimiter__text form-delimiter__text--188"}>
                Szczegóły wydarzenia
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <input
                  className={
                    errors.datetime?.type === "required" ? "error" : ""
                  }
                  type={"datetime-local"}
                  {...register("datetime", {
                    required: true,
                  })}
                />
              </div>

              <div className="form-group">
                <input
                  className={errors.amount?.type === "required" ? "error" : ""}
                  placeholder="Przybliżona liczba gości"
                  type={"number"}
                  {...register("amount", {
                    required: true,
                  })}
                />
              </div>
            </div>

            <div className="form-group">
              <textarea
                className={errors.message?.type === "required" ? "error" : ""}
                placeholder="Dodatkowa wiadomość (opcjonalne)"
                {...register("message", {
                  required: true,
                })}
              />
            </div>
            <div className="client-form__buttons">
              <button type="submit" className={"button button--primary"}>
                <Send />
                Wyślij zapytanie
              </button>
              {success && (
                <FormFeedback
                  text={"Wysłane! Wkrótce się odezwiemy."}
                  success={true}
                />
              )}
              {!success && Object.keys(errors).length > 0 && (
                <FormFeedback
                  text={"Zaznaczone pola nie mogą być puste."}
                  success={false}
                />
              )}

              {!success && systemError && (
                <FormFeedback
                  text={"Wystąpił błąd, spróbuj ponownie."}
                  success={false}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </form>
  )
}

export default Estimate
